import {getSegmentGroups} from '@/services/segments'
import {useQuery} from '@tanstack/react-query'
import {useMemo} from 'react'

export const useSegmentsList = (searchQuery = '') => {
  const {data, isLoading} = useQuery({
    queryKey: ['SEGMENTS_LIST', searchQuery],
    queryFn: () => getSegmentGroups(searchQuery),
  })

  const segmentGroupData = useMemo(() => {
    // Map the API response to the format expected by the component
    return (data?.data || []).map(group => ({
      id: group.segmentGroupId || group.id,
      name: group.segmentGroupName || group.name,
      count: parseInt(group.segmentCount || group.count) || 0,
      segments: Array(parseInt(group.segmentCount || group.count) || 0)
        .fill()
        .map((_, i) => ({
          id: `segment-${i}`,
          name: `Segment ${i + 1}`,
        })),
    }))
  }, [data?.data])

  return {
    segmentsGroups: data?.data || [],
    segmentGroupData,
    isLoading,
  }
}
